import { render, staticRenderFns } from "./MedicineListing.vue?vue&type=template&id=24d9a2d4&scoped=true"
import script from "./MedicineListing.vue?vue&type=script&lang=js"
export * from "./MedicineListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d9a2d4",
  null
  
)

export default component.exports